export const transmissionTitleAction = {
  setTitle: (state, action) => {
    const role = localStorage.getItem("role");
    const clinicName = localStorage.getItem("clinicName");
    const { view, type, title } = action.payload;

    if (type === "transmission") {
      if (role === "clinic") {
        const clinicTabMapper = {
          clinic: "Active",
          "clinic-review": "Processed",
          "clinic-processed": "Signed/Archived",
          "heart-failure": "Heart Failure",
        };

        if (clinicTabMapper[view]) {
          state.title =
            clinicName !== "None"
              ? `${clinicName} - ${clinicTabMapper[view]} Transmissions`
              : `${clinicTabMapper[view]} Transmissions`;
          return;
        }
      } else {
        state.title = `${view} Transmissions`;
      }
    } else {
      state.title = title;
    }
  },
};
